<template>
  <div class="homeBanner">
    <el-carousel indicator-position="none" height="88vh" arrow="hover">
      <el-carousel-item v-for="item in list" :key="item">
        <img :src="staticUrl+item.image" alt="" style="width: 100%;height: 100%;">
      </el-carousel-item>
    </el-carousel>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      default:[]
    }
  },
  data() {
    return {
      staticUrl:this.STATICURL
    }
  },
  mounted() {


  },

  methods: {}

}
</script>
<style scoped>
.homeBanner {
  width: 100vw;
  height: 100vh;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>